import isArray from "@homer.utility/validator.isarray";
import isObject from "@homer.utility/validator.isobject";

export default function sort(object) {
    if (!isObject(object)) {
        throw new TypeError("argument `object` must be of type `object`, received `" + typeof object + "`");
    }

    return Object.keys(object)
        .sort()
        .reduce((target, key) => {
            const value = object[key];

            target[key] = isObject(value) && !isArray(value) ? sort(value) : value;

            return target;
        }, {});
}
